import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

interface DTO {
    parkingId: string;
}

const RESOURCE = '/parkings/:parkingId/parking-borica-settings/payments-status/';

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<{ are_borica_payments_enabled: boolean }> => {
    return axios.get(
        formatResourcePath(RESOURCE, {
            parkingId,
        }),
        { params },
    );
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });
};

export { useQueryHook as useBoricaPaymentsStatus, RESOURCE as BORICA_PAYMENTS_RESOURCE };
